import React from "react";
import { useState } from "react";
import { convertArrayToCSV } from 'convert-array-to-csv';
import FileSaver from 'file-saver';
import "../Dashboard/Dashboard.css";
import { toast } from "react-toastify";
import { TRANSACTION_HISTORY } from "../../redux/Transactionhistory/types";
import { useEffect } from "react";
import { useDispatch } from "react-redux/es/exports";
import { useSelector } from "react-redux/es/exports";
import { AskpageNumber } from "../Model/AskpageNumber";
import Pagination from "../../utils/Pagination";
import axiosinstances from "../../Helper/useAxios";
import { isSuperAdmin, isUserAdmin } from "../../utils/comman/Common";
import { useNavigate } from "react-router-dom";
import { selectedRetailer } from "../../redux/SelectedRetailer/action";
import { setpageContent } from "../../utils/Constant";

const AdminHome = () => {
  const [axiosInstance] = axiosinstances()
  const requesterId = useSelector((state) => state.selectedretailerReqesterReducer.requesterId);
  const navigate = useNavigate();
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const [showModal, setShowModel] = useState(false)
  const [selectedPage, setSelectedPage] = useState(1);
  const [search, setsearch] = useState("");
  const [paginationDetails, setPaginationDetails] = useState({
		currentPage: 1,
		postsPerPage: 20,
    totalPost :0,
    totalPages:0
	})
  const [dataLoading, setDataLoading] = useState(false)
  const [table, settable] = useState([]);
  const dispatch = useDispatch();
  

  const fetchListOfRetailer = async (pageNo) => {
    setDataLoading(true)
    console.log('requesterId', requesterId)
    let url = `/api/v1/retailer/list/${pageNo}`
    if(requesterId !== undefined ){
      url= `/api/v1/retailer/list/${pageNo}/${requesterId}`
    }
    const response = await  axiosInstance
    .get(url, {
      headers: {
        Authorization: `Bearer ${e}`,
        "client-id": id,
        role: "ROLE_RETAILER_FINXPAY",
      },
    })
   .then((res) => {
    //console.log('res....>', res)
    //  return res
    settable(res.data.retailers)
    setDataLoading(false)
    setPaginationDetails((prev)=>{
      return({
        ...prev, 
        totalPost: res.data?.totalElements,
        totalPages:res.data?.totalPages,
        currentPage:res.data?.currentPage + 1
      })
    })
   })
   .catch((err) => {
     //console.log(err);
     setDataLoading(false)
     toast.error("Something went wrong");
   });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  useEffect(() => {
    fetchListOfRetailer(0)
  }, []);

  
  const Transactiontable = useSelector(
    (state) => state.transactionhistoryreducer.Transaction
  );
  const a = useSelector((state) => state.transactionhistoryreducer.Transaction);
  const responseobject = useSelector(
    (state) => state.getclaimdatareducer.getclaimdata
  );

  const handalpageclick = async (index) => {
   
    fetchListOfRetailer(index-1);
 
  };
  const totalpage = paginationDetails.totalPages;
 
  const d =
    sessionStorage.getItem("token") &&
    JSON.parse(sessionStorage.getItem("token")).token
      ? JSON.parse(sessionStorage.getItem("token")).token
      : "";
  const e = JSON.parse(sessionStorage.getItem("token"));

  const searchdata = async () => {
    setsearch((search) => {
      return search;
    });
    const callingsearchapi = await searchapidata(search);

    setsearch("")

  };


 

  const searchapidata = async (search) => {
  const trimSearch = search.trim()
    const response = await  axiosInstance
    .get(`/api/v1/retailer/search/${trimSearch}`, {
      headers: {
        Authorization: `Bearer ${e}`,
        "client-id": id,
        role: "ROLE_RETAILER_FINXPAY",
      },
    })
   .then((res) => {
    settable(res.data.retailers)
    setDataLoading(false)
    setPaginationDetails((prev)=>{
      return({
        ...prev, 
        totalPost: res.data?.totalElements,
        totalPages:res.data?.totalPages,
        currentPage:res.data?.currentPage + 1
      })
    })
   })
   .catch((err) => {
     //console.log(err);
     toast.error("Something went wrong");
   });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };


  const fetchpagedataInloop = async (pageNo) => {
  
    const response = await  axiosInstance
    .get(`/api/v1/retailer/list/${pageNo}/${requesterId}`, {
      headers: {
        Authorization: `Bearer ${e}`,
        "client-id": id,
        role: "ROLE_RETAILER_FINXPAY",
      },
    })
   .then((res) => {
    //console.log('res....>', res)
    return res
    
   })
   .catch((err) => {
     //console.log(err);
     toast.error("Something went wrong");
   });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };
 
  const enterTxnsearch = (event) => {
    event.preventDefault();

    setsearch(event.target.value);
  };
 
  // const myArray = Array.apply(null, { length: totalpage }).map(
  //   Number.call,
  //   Number
  // );
  //console.log('myArray', myArray)
  const nextclick = () => {
    setsearch(search + 1);
    setsearch((search) => {
      return search;
    });
  };
 
const onExportData  = () =>{
 
  setShowModel(true)

}
const pageHandler = (page) =>{
  //console.log('page', page)
  }
const closePopUp = () =>{
  setShowModel(false)
  setSelectedPage(1)
}

async function exportAllFile(){
  let result=[]
  for(let i = 0; i < selectedPage; i++){
    const  data = await fetchpagedataInloop(i);
    if(Array.isArray(data?.retailers)){
     const unwantedHeaderForExcel = data.retailers.map(val=>{
        delete val.optional
        delete val.transaction
        //console.log('val11', val)
        const newvalues = val
        //console.log('newvalues', newvalues)
        return newvalues
      })
      result.push(...unwantedHeaderForExcel)
     
    }
     
  }
  //console.log('result', result)
  const csv = convertArrayToCSV(result)
  const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  FileSaver.saveAs(csvData, 'data.csv');
  closePopUp()
  setSelectedPage(1)
}
const AddNewClients = ()=>{
  navigate('/add-new-client')
}
const clearSearch = () =>{
  setsearch('')
  dispatch({ type: TRANSACTION_HISTORY, id })
}
const profileDetails = (data) =>{
  dispatch(selectedRetailer({id:data.id,name:data.businessInfo.name}))
  sessionStorage.setItem("rname",data.businessInfo.name)
  sessionStorage.setItem("rid",data.id)
  navigate(`/profile/${data?.id}`)
}
  return (
    <React.Fragment>
    
    <AskpageNumber showModal={showModal}
   closePopUp = {closePopUp}
   totalpage={totalpage} 
   setSelectedPage={setSelectedPage} 
   selectedPage ={selectedPage}
   exportAllFile={exportAllFile}
   />
   {
  isUserAdmin(id) && 
   
      <div class="mid">
        <div class="container-fluid">
          <div class="maincard">
            <div class="tab-content" id="mobiletab">
              <div
                class="tab-pane fade show active"
                id="nav-mobi"
                role="tabpanel"
                aria-labelledby="mobile-tab"
              >
                <div class="head">
                  <h3>Retailer List</h3>
                  {!isSuperAdmin(id) && <button class="btn" type="button" onClick={AddNewClients}>Add New Client</button>}
                  <div class="headsearch">
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        onChange={(event) => enterTxnsearch(event)}
                        placeholder="Search Retailer id..."
                        value={search}
                      />
                      <button
                        class="btn search"
                        disabled={search.length <= 3}
                        type="button"
                        id="txnsrch"
                        onClick={searchdata}
                      >
                        search
                      </button>
                      <button
                      style={{background:'#FF8D33', marginLeft:'3px'}}
                        class="btn delete"
                       // disabled={search.length <= 3}
                        type="button"
                        
                        onClick={clearSearch}
                      >
                        clear
                      </button>
                    </div>
                    
                  </div>
                  
                </div>
                
                <div class="txn-list" id="recntxn">
                  { dataLoading ? <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                    </div>
                    </div> :<>
                  {table !== undefined && table?.map((data) => {
                    return (
                      <div onClick={()=>profileDetails(data)} class="txn-item" key={data.id}>
                        <div class="txn-head" id="txnhead1">
                          <div
                            class="collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#txn1"
                            aria-expanded="false"
                            aria-controls="txn1"
                          >
                            <div
                              class={`txncard ${
                                data.status === "ACTIVE"
                                  ? "success grbg"
                                  : `${
                                    data.status === "INACTIVE" ||
                                    data.status === "SUSPENDED" ||
                                    data.status === "FLAGGED" 
                                        ? "pending ylbg"
                                        : "failed rdbg"
                                    }`
                              }`}
                            >
                              <div class="row">
                                <div class="col-12 col-md-5">
                                  <div class="txntxt">
                                    {/* <li className="bill"> */}
                                    {/* <img src={require('../../assests/images/airtel.png')} alt="logo"/> */}
                                      <h5>
                                        {data.businessInfo.name}
                                        
                                      </h5>
                                    {/* </li> */}
                                  </div>
                                  <div class="txntxt">
                                    <h6>Mobile No.: {data?.personalInfo.mobile}</h6>
                                  </div>
                                </div>
                                {/* <div class="col-12 col-sm-5 col-lg-3">
                                  <div class="txntxt">
                                    <h6>Txn ID: {data.requestId}</h6>
                                  </div>
                                </div> */}

                                <div class="col-12 col-md-5">
                                  <div class="txntxt">
                                    <h6>Retailer ID: {data.id}</h6>
                                    <h6>Date and Time: <span> {data.createdOn
                                            .replace("T", " ")
                                            .slice(0, -4)} </span> </h6>
                                  </div>
                                </div>
                                <div class="col-12 col-md-2">
                                  <div class="txntxt">
                                    {/* <h4>
                                      ₹ {200}{" "}</h4> */}
                                      <h4> Status : <span
                                        class={`${
                                          data.status === "ACTIVE"
                                            ? "success"
                                            : `${
                                                data.status === "INACTIVE" ||
                                                data.status === "SUSPENDED" ||
                                                data.status === "FLAGGED" 
                                                  ? "pending"
                                                  : "failed"
                                              }`
                                        }`}
                                      >
                                        {data.status}
                                      </span>
                                     
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  
                  
                  <div class="pager">
                    {
                      table !== undefined && table !== null && table.length > 0 && search == '' &&
                       <p>
                       {/* Showing 1 to {table.length < 10 ? table.length : table.length} of { table !== undefined && table !== null && paginationDetails.totalPost} entries{" "} */}
                       {paginationDetails.currentPage !== undefined && paginationDetails.currentPage !== null  && paginationDetails.totalPost !== undefined && paginationDetails.totalPost !== null &&  table !== undefined && Array.isArray(table) && setpageContent(paginationDetails.currentPage - 1, table.length, paginationDetails.totalPost)}
                       {/* <button class="lbbtn" type="button" onClick={onExportData}>
                         Export
                       </button> */}
                     </p>
                    }
                   
                    {
                      paginationDetails.totalPost !== undefined && paginationDetails.totalPost !== null && paginationDetails.totalPost > 10 && search == '' &&
                     <Pagination
                     className="pagination-bar"
                     currentPage={paginationDetails.currentPage}
                     totalCount={paginationDetails.totalPost}
                     pageSize={paginationDetails.postsPerPage}
                     onPageChange={page => 
                       handalpageclick(page)
                     }
                     />
                      // <Pagination  postsPerPage={paginationDetails.postsPerPage} totalPosts={table.length} paginate={paginate} currentPage={paginationDetails.currentPage} />
                     
                        }
                  </div>
                  </>}
                </div>
              </div>
             
              <div
                class="tab-pane fade"
                id="mobi-grap"
                role="tabpanel"
                aria-labelledby="mobi-grap-tab"
              >
                {/* <TransactionGraph/>  */}
              </div>
            </div>
          </div>
        </div>
      </div>
}
    </React.Fragment>
  );
};

export default AdminHome;
